export enum CompanySocialLinkEnum {
	facebook = "facebook", // keep order of enum for ranking purposes
	bluesky = "bluesky",
	instagram = "instagram",
	letterboxd = "letterboxd",
	linkedin = "linkedin",
	pinterest = "pinterest",
	snapchat = "snapchat",
	threads = "threads",
	tiktok = "tiktok",
	tumblr = "tumblr",
	twitter = "twitter",
	vk = "vk", // VKontakte
	wechat = "wechat",
	whatsapp = "whatsapp",
	youtube = "youtube",
}

export type SocialLinks = {
	[K in CompanySocialLinkEnum]?: string | null
}

export const SOCIAL_LINK_KEYS = Object.values(CompanySocialLinkEnum)

export type SocialLinkDetails = {
	[K in CompanySocialLinkEnum]: {
		value: CompanySocialLinkEnum
		label: string
	}
}

export const socialLinkDetailsOptions: SocialLinkDetails = SOCIAL_LINK_KEYS.reduce((acc, socialLinkKey) => {
	let label = CompanySocialLinkEnum[socialLinkKey].toString()
	label = label.charAt(0).toUpperCase() + label.slice(1) // Capitalize first letter

	if (socialLinkKey === CompanySocialLinkEnum.linkedin) label = "LinkedIn"
	else if (socialLinkKey === CompanySocialLinkEnum.tiktok) label = "TikTok"
	else if (socialLinkKey === CompanySocialLinkEnum.vk) label = "VKontakte"
	else if (socialLinkKey === CompanySocialLinkEnum.wechat) label = "WeChat"
	else if (socialLinkKey === CompanySocialLinkEnum.whatsapp) label = "WhatsApp"
	else if (socialLinkKey === CompanySocialLinkEnum.youtube) label = "YouTube"

	acc[socialLinkKey] = {
		value: socialLinkKey,
		label,
	}
	return acc
}, {} as SocialLinkDetails)
